const RegistrationDetails = () => {
  const fundData = [
    {
      name: "JM Financial Yield Enhancer Distressed Opportunity Fund I",
      regNo: "IN/AIF2/19-20/0719",
    },
    {
      name: "JM Financial Credit Opportunities Fund",
      regNo: "IN/AIF2/22-23/1193",
    },
    {
      name: "JM Financial India Real Estate Trust",
      regNo: "IN/AIF2/25-26/1813",
    },
    {
      name: "JM Financial Select Credit Strategy",
      regNo: "IN/AIF2/25-26/2059",
    },
    {
      name: "JM Financial Pre IPO Trust",
      regNo: "IN/AIF2/25-26/2047",
    },
  ];

  return (
    <div className="page">
      <div className="card">
        <h2 className="titlee">
          Disclosure pertaining to SEBI Circular dated February 26, 2026 – Ease
          of Doing Investment (EoDI) – Disclosure of registered name and
          registration number by SEBI regulated entities and their agents on
          Social Media Platforms (SMPs)
        </h2>

        <p className="entity">
          <strong>Regulated Entity:</strong> JM Financial Asset Management
          Limited
        </p>

        <table className="table">
          <thead>
            <tr>
              <th style={{ width: "75%" }}>SEBI Registered Name</th>
              <th style={{ width: "25%" }}>Registration No.</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>JM Financial Mutual Fund</td>
              <td>MF/015/94/8</td>
            </tr>

            <tr>
              <td>
                JM Financial Asset Management Limited (Co-Investment Portfolio
                Manager Services Only)
              </td>
              <td>INP000009719</td>
            </tr>

            <tr>
              <td colSpan="2" className="section">
                Alternative Investment Funds:
              </td>
            </tr>

            {fundData.map((item, index) => (
              <tr key={index}>
                <td>• {item.name}</td>
                <td>{item.regNo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .page {
          background: #f4f4f4;
          min-height: 100vh;
          display: flex;
          justify-content: center;
          padding: 40px 20px;
        }

        .card {
          background: #fff;
          width: 100%;
          max-width: 850px;
          padding: 35px;
          border-radius: 6px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
        }

        /* FIX 1: Perfect Center Title */
        .titlee {
          display: block;
          width: 100%;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          text-decoration: underline;
          line-height: 1.6;
          margin-bottom: 25px;
          color: #013c66;
        }

        .entity {
          font-size: 14px;
          margin-bottom: 15px;
        }

        /* FIX 2: Strong, consistent borders */
        .table {
          width: 100%;
          border-collapse: collapse;
          border: 2px solid #000; /* outer border FIX */
          font-size: 14px;
        }

        .table th,
        .table td {
          border: 1.5px solid #000; /* thicker inner lines */
          padding: 10px;
          vertical-align: top;
        }

        /* FIX 3: header clarity */
        .table th {
          font-weight: 700;
          text-align: left;
          background: #f2f2f2;
        }

        /* FIX 4: Section row */
        .section {
          font-weight: 700;
          text-decoration: underline;
          background: #fafafa;
        }

        /* Remove faded effect (important) */
        .table tr:first-child th {
          border-top: 2px solid #000;
        }

        @media (max-width: 768px) {
          .card {
            padding: 20px;
          }

          .title {
            font-size: 14px;
          }

          .table {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default RegistrationDetails;
